const hostPublic = 'eventsgo/media/'
const mock = ''
// 展会搜索列表
export const GET_EXHI_LIST = hostPublic + 'services/eventsgo/public/exhibitions/findExhibitionsPagedList'
// 热门酒店展示
export const GET_HOT_HOTEL = hostPublic + 'services/eventsgo/public/exhibitions/findHotExhibitionsList'
// 获取资源首页展会配置
export const GET_RES_EXHI_CONFIG = mock + hostPublic + 'services/eventsgo/public/exhibitions/findExhibitionConfigInfo'
// 获取资源首页业务锁逻辑
export const GET_RES_BUSINESS_LOCK = hostPublic + 'services/eventsgo/public/exhibitions/findLockedOrNotByExhiId'
